import { createFileRoute } from '@tanstack/react-router'

import { FEATURE_LEARNPATH_EMBEDDED_VIDEO } from '@/core/constants/features'
import useFeatures from '@/core/utils/features/useFeatures'
import { LearnpathsAddElementsEmbeddedVideo } from '@/learnpaths/components/LearnpathsAddElementsEmbeddedVideo/LearnpathsAddElementsEmbeddedVideo'

export const Route = createFileRoute(
  '/company/learnpaths/add/elements/$learnpathId/(embedded-video)/create/embedded-video',
)({
  component: RouteComponent,
  validateSearch: (search: { index?: number }) => search,
})

function RouteComponent() {
  const hasLearnpathEmbeddedVideoFeature = useFeatures(
    FEATURE_LEARNPATH_EMBEDDED_VIDEO,
  )
  const params = Route.useParams()

  if (!hasLearnpathEmbeddedVideoFeature) {
    return null
  }

  return <LearnpathsAddElementsEmbeddedVideo mode="create" {...params} />
}
